import { textBodySmall } from '../../../styles/typography';
import { classNames } from '../../../utils/style';
import React, { ReactNode } from 'react';

export interface DetailedTableOfContentHeadingProps {
  isSubheading?: boolean;
  children: ReactNode[];
}
export const Headings = ({
  isSubheading,
  children,
}: DetailedTableOfContentHeadingProps) => {
  return (
    <ul>
      {children.map((child, key) => (
        <li
          className={classNames(
            textBodySmall,
            'font-semibold text-left',
            !isSubheading && 'text-neutral-301 py-8',
            isSubheading && 'text-neutral-300 pt-8',
          )}
          key={key}
        >
          {child}
        </li>
      ))}
    </ul>
  );
};
